import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from 'api/common/constants';

const TRANSFER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.TRANSFER,
  false
);
export const TransferApi = {
  transferForm: () => {
    const url = `${TRANSFER_BASE}/form`;
    return apiClient.get(url);
  },

  transferEditForm: id => {
    const url = `${TRANSFER_BASE}/form?is_edit=true&transfer_id=${id}`;
    return apiClient.get(url);
  },

  createTransfer: combinedData => {
    const url = `${TRANSFER_BASE}`;
    return apiClient.post(url, combinedData);
  },

  updateTransfer: (id, combinedData) => {
    const url = `${TRANSFER_BASE}/${id}`;
    return apiClient.put(url, combinedData);
  }
};
